import React, { useEffect, useState } from 'react';

type ImageLoadingBarProps = {
  preview: string;
};

export const ImageLoadingBar: React.FC<ImageLoadingBarProps> = ({
  preview,
}: ImageLoadingBarProps): JSX.Element => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const animation = setTimeout(() => {
      setLoading(false);
    }, 600);
    return () => clearTimeout(animation);
  }, [loading]);

  return loading ? (
    <div className="image-loading app-preview" />
  ) : (
    <img className="app__preview" src={preview} alt="Feature preview" />
  );
};
